@file:OptIn(InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/chartsproject.app.generated.resources/"

@delegate:ResourceContentHash(1_502_484_583)
public val Res.drawable.ic_check: DrawableResource by lazy {
      DrawableResource("drawable:ic_check", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_720_401_342)
public val Res.drawable.ic_dark_mode: DrawableResource by lazy {
      DrawableResource("drawable:ic_dark_mode", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_dark_mode.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_405_938_115)
public val Res.drawable.ic_launcher_foreground: DrawableResource by lazy {
      DrawableResource("drawable:ic_launcher_foreground", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_launcher_foreground.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-536_874_291)
public val Res.drawable.ic_replay: DrawableResource by lazy {
      DrawableResource("drawable:ic_replay", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_replay.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_794_967_508)
public val Res.drawable.ic_visibility_off: DrawableResource by lazy {
      DrawableResource("drawable:ic_visibility_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visibility_off.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(699_330_369)
public val Res.drawable.ic_visibility_on: DrawableResource by lazy {
      DrawableResource("drawable:ic_visibility_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_visibility_on.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_check", Res.drawable.ic_check)
  map.put("ic_dark_mode", Res.drawable.ic_dark_mode)
  map.put("ic_launcher_foreground", Res.drawable.ic_launcher_foreground)
  map.put("ic_replay", Res.drawable.ic_replay)
  map.put("ic_visibility_off", Res.drawable.ic_visibility_off)
  map.put("ic_visibility_on", Res.drawable.ic_visibility_on)
}
